import React from 'react';
import { STATUS_COLORS } from './formatters';

export default function StatusBadge(props) {
  var c = STATUS_COLORS[props.status] || STATUS_COLORS.held;
  return (
    <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium" style={{ backgroundColor: c.bg, color: c.text }}>
      <span style={{ width: 5, height: 5, borderRadius: '50%', backgroundColor: c.dot, display: 'inline-block' }} />
      {props.label || props.status || 'held'}
    </span>
  );
}
